(function(){
	'usestrict';
	var deleteDialogTemplateUrl = require('./deleteDialog.template');
	angular
		.module('smb-app')
		.factory('smbDeleteDialogService',[
			'$mdDialog',
			DeleteDialogService
		])
		.controller('DeleteDialogController', [
			'$mdDialog',
			'title',
			'message',
			'showPurgeOption',
			'purgeText',
			DeleteDialogController
		]);

	function DeleteDialogService($mdDialog){
		return {
			show: function(event, title, message, showPurgeOption, purgeText) {			
				return $mdDialog.show({
					controller: 'DeleteDialogController',
					controllerAs: 'vm',
					templateUrl: deleteDialogTemplateUrl,
					targetEvent: event,
					locals: {
						title: title,
						message: message,
						showPurgeOption: showPurgeOption,
						purgeText: purgeText 
					},
					clickOutsideToClose: false
				});
			}
		};
	}

	function DeleteDialogController($mdDialog, title, message, showPurgeOption, purgeText) {
		var vm = this;
		vm.title = title;
		vm.message = message;
		vm.showPurgeOption = showPurgeOption || false;
		vm.purgeText = purgeText;
		vm.permanentlyDelete = false;
		vm.delete = function() {
			$mdDialog.hide(vm.permanentlyDelete);
		};
		vm.cancel = function() {
			$mdDialog.cancel();
		};
	}
})();



//////////////////
// WEBPACK FOOTER
// ./app/services/deleteDialogService/deleteDialogService.js
// module id = 147
// module chunks = 1